import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { creditStatus } from '../redux/Selectors.js';
import { MessageBox } from '../components/ModalDialog';

/**
 * ASE-551 / ZEN-30575: Hinweis fuer gesperrte Kunden.
 *
 * Ist der Kunde in AdSuite gesperrt (`blocking` oder `creditWorthinessReaction` = 'block',
 * z.B. durch eine Mahnsperre), bietet der WebStore keine Zahlungsart mehr an. Ohne Hinweis
 * stuende der Kunde vor einer leeren Auswahl, ohne zu wissen warum.
 *
 * Der Polymer-WebStore zeigt die Meldung seit jeher auf App-Ebene (bazaar-app.html:1375), in
 * React fehlte sie: der Selektor {@link creditStatus} existierte, wurde aber von keiner
 * Komponente ausgewertet. Als Service-Komponente neben den uebrigen Services gemountet, gilt
 * sie fuer alle drei Oberflaechen (Desktop, barrierefrei, mobil) gleichermassen.
 */
export const CreditStatusGuard = () => {
    const _creditStatus = useSelector(state => creditStatus(state));
    const [open, setOpen] = useState(false);
    // Die Meldung soll einmal je Sperrzustand kommen, nicht bei jedem Re-Render erneut.
    const announced = useRef(false);

    useEffect(() => {
        if (_creditStatus === 'block') {
            if (!announced.current) {
                announced.current = true;
                setOpen(true);
            }
        }
        else {
            announced.current = false;
        }
    }, [_creditStatus]);

    return (
        <MessageBox
            open={open}
            handleClose={() => setOpen(false)}
            message="main.creditStatusError"
            severity="error">
        </MessageBox>
    );
};

export default CreditStatusGuard;
